import { getCssSizeValue, getFontSize, getHtmlFromRedactorField, getMarginsData } from "@/utils/utils"
import styled from "styled-components"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { useStructuredContext } from "@/components/common/StructuredText"
import GridContainer from "@/components/common/GridContainer"
import Text from "@/components/common/Text"
import { useEffect, useRef } from "react"
import { useViewportWidth } from "@/hooks/useViewport"
import useDevice from "@/hooks/useDevice"
import DynamicMargin from "@/components/common/DynamicMargin"

const MARGIN_SIZES = {
	TOP: {
		MOBILE: 48,
		TABLET: 48,
		DESKTOP: 48,
	},
	BOTTOM: {
		MOBILE: 48,
		TABLET: 48,
		DESKTOP: 48,
	},
}

const Wrapper = styled.div`
	position: relative;
`

const StyledQuote = styled.div`
	.text {
		font-style: italic;
		font-family: var(--font-strawford) !important;
		font-weight: 300 !important;
		font-size: ${getFontSize(14, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
			font-size: ${getFontSize(14, BREAKPOINTS.TABLET)};
		}
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			font-size: ${getFontSize(20, BREAKPOINTS.DESKTOP)} !important;
			line-height: ${getFontSize(34, BREAKPOINTS.DESKTOP)} !important;
		}
	}

	margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
	}
`

const StyledBarWrapper = styled(GridContainer)`
	top: 0;
	left: 0;
	position: absolute;
	width: 93%;
	height: ${({ $height }) => ($height ? `${$height}px` : "100%")};
`

const StyledBar = styled.div`
	position: absolute;
	background: ${({ theme }) => theme.colors.richBlack};
	height: 100%;
	width: 3px;
	left: 0;
	translate: ${getCssSizeValue(-10, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		translate: ${getCssSizeValue(-10, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		right: 0;
		translate: ${getCssSizeValue(10, BREAKPOINTS.DESKTOP)};
		left: unset;
	}
`

export default function Quote({ data, children }) {
	const { isMobile, isTablet, isDesktop } = useDevice()
	const author = data?.attribution || ""
	const indent = useStructuredContext("indent")
	const { marginTop, marginBottom } = getMarginsData(data)

	const quoteRef = useRef(null)
	const quoteHeight = useRef(null)
	const vw = useViewportWidth()

	useEffect(() => {
		if (quoteRef.current) {
			quoteHeight.current = quoteRef.current.offsetHeight
		}
	}, [vw, isMobile, isTablet, isDesktop])

	return (
		<DynamicMargin marginTop={marginTop} marginBottom={marginBottom} marginSizes={MARGIN_SIZES}>
			<Wrapper ref={quoteRef}>
				<StyledQuote>{children}</StyledQuote>
				<StyledBarWrapper className={`indent-desktop-${indent - 1}`}>
					<StyledBar $height={quoteHeight.current} className="col-desktop-1 col-tablet-1 col-mobile-1" />
				</StyledBarWrapper>
				<GridContainer className={`indent-desktop-${indent}`}>
					<Text
						as="div"
						className="typo-strawford typo-strawford-129 col-mobile-8 col-tablet-8 col-desktop-6"
						dangerouslySetInnerHTML={getHtmlFromRedactorField(author)}
					/>
				</GridContainer>
			</Wrapper>
		</DynamicMargin>
	)
}
